// The hand-written connection registry: exactly one entry per generated schema
// entity, each assembled in its own `Connections/<Model>.ts` module. The mapped
// `ConnectionRegistry` type makes this exhaustive — omitting an entity fails `tsc`
// — and `bindSchema` (BindSchema.ts) validates the wiring against `Schema.ts` at
// runtime.
//
// The shared connection vocabulary (the `Connection` shape, the `entity()` helper,
// `ownerFkIndexes`, `softDeleteEntities`, …) lives in `Connections/Connection.ts`
// and is re-exported here, so `./Connections` stays the single import surface for
// the whole layer.
import type { ConnectionRegistry } from "./Connections/Connection"
import { AccountEntity } from "./Connections/Account"
import { AccountUserEntity } from "./Connections/AccountUser"
import { AccountSubscriptionPlanEntity } from "./Connections/AccountSubscriptionPlan"
import { AccountSubscriptionPlanFeatureEntity } from "./Connections/AccountSubscriptionPlanFeature"
import { AccountSubscriptionPlanPricingEntity } from "./Connections/AccountSubscriptionPlanPricing"
import { AuditLogEditEntity } from "./Connections/AuditLogEdit"
import { CruiseEntity } from "./Connections/Cruise"
import { DataRecordEntity } from "./Connections/DataRecord"
import { DayEntity } from "./Connections/Day"
import { LogEntity } from "./Connections/Log"
import { NoteEntity } from "./Connections/Note"
import { NoteAttachmentEntity } from "./Connections/NoteAttachment"
import { SettingsEntity } from "./Connections/Settings"
import { ShipEntity } from "./Connections/Ship"
import { ShipUserEntity } from "./Connections/ShipUser"
import { StatusEntity } from "./Connections/Status"
import { StoredCalculationEntity } from "./Connections/StoredCalculation"
import { TrackEntity } from "./Connections/Track"
import { TripEntity } from "./Connections/Trip"
import { UserEntity } from "./Connections/User"

export * from "./Connections/Connection"

export const connections: ConnectionRegistry = {
  Account: AccountEntity,
  AccountUser: AccountUserEntity,
  AccountSubscriptionPlan: AccountSubscriptionPlanEntity,
  AccountSubscriptionPlanFeature: AccountSubscriptionPlanFeatureEntity,
  AccountSubscriptionPlanPricing: AccountSubscriptionPlanPricingEntity,
  AuditLogEdit: AuditLogEditEntity,
  Cruise: CruiseEntity,
  DataRecord: DataRecordEntity,
  Day: DayEntity,
  Log: LogEntity,
  Note: NoteEntity,
  NoteAttachment: NoteAttachmentEntity,
  Settings: SettingsEntity,
  Ship: ShipEntity,
  ShipUser: ShipUserEntity,
  Status: StatusEntity,
  StoredCalculation: StoredCalculationEntity,
  Track: TrackEntity,
  Trip: TripEntity,
  User: UserEntity,
};
